import BaseCardBehavior from './BaseCardBehavior';
import CardStateHelper, { getCardsState } from '../CardStateHelper';
import { CardModifierType } from '../../../Prototype/Level/Card/CardModifierType';
import { CardTask } from '../CardTasks';
import { SCORE_ROCK_CARD } from '../../../Constants/Score';
import { CardType } from '../../../Prototype/Level/Card/CardType';
import { CardState } from 'Prototype/Level/Card/CardState';
import { IGameState } from 'State/Game/IGameState';
import CardStateModifierHelper from '../CardStateModifierHelper';

export default class RockCardBehavior extends BaseCardBehavior {
    public update(state: IGameState): IGameState {
        let cardsState = state.levelState.cardsState;
        const pickaxeCardIds = CardStateHelper.getCardsInPlay(state.levelState.cardsState, {
            requireCardModifierTypes: [CardModifierType.pickaxe],
        });

        // If there are no pickaxe modifiers left in-play then this card is discarded.
        if (pickaxeCardIds.length === 0 && CardStateHelper.getCardState(state, this.cardID) === CardState.IN_PLAY) {
            cardsState = CardStateHelper.addTurnScore(cardsState, SCORE_ROCK_CARD);

            if (!cardsState.tasks.find(task => task.task === CardTask.ROCK)) {
                const cardsIDs: string[] = [];

                cardsState.inPlay.forEach((cardID: string) => {
                    if (cardsState.cards[cardID].type === CardType.rock) {
                        cardsIDs.push(cardID);
                    }
                });

                cardsState = CardStateHelper.setStateTaskData(cardsState, {
                    task: CardTask.ROCK,
                    cards: cardsIDs,
                });

                state = CardStateHelper.updateGameState(state, cardsState);
                state = CardStateHelper.setCardDiscarded(state, ...cardsIDs);
                cardsState = getCardsState(state);
            }

            // Clear the undo history when the rock is discarded.
            cardsState = CardStateHelper.clearUndoHistory(cardsState);

            state = CardStateHelper.updateGameState(state, cardsState);
            state = CardStateHelper.updateCards(state);
            state = CardStateModifierHelper.onCardPlayed(state, this.cardID);
        }

        return super.update(state);
    }

    public isPlayable(state: IGameState): boolean {
        return false;
    }
}
